import React from "react";
export interface IProps {
    item: any;
    display: (item: any) => string;
}
export default function BasicTypeaheadResult(props: IProps) {
    return <span>{props.display(props.item)}</span>;
}
